import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// @styles
import './BoxTabs.scss';

//TODO: esta clase debe venir de open-components
class BoxTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabSelected: this.props.selectedTab,
        };
    }

    callBackTab = index => {
        this.setState({ tabSelected: index });

        this.props.callBack && this.props.callBack(index);
    };

    buildOptions = () => {
        const { children } = this.props;
        if (children) {
            return children.map((option, index) => {
                const optionStyle = classNames('open-tab-box__option', {
                    '-selected': index === this.state.tabSelected,
                    '-uppercase': this.props.uppercase,
                });

                return (
                    <li className={optionStyle} key={index} onClick={() => this.callBackTab(index)}>
                        {option}
                    </li>
                );
            });
        }
        return null;
    };
    render() {
        const { styleTabs } = this.props;
        return <ul className={`open-tab-box -${styleTabs}`}>{this.buildOptions()}</ul>;
    }
}

BoxTabs.propTypes = {
    onClick: PropTypes.func.isRequired,
    uppercase: PropTypes.bool,
    children: PropTypes.node,
    selectedTab: PropTypes.number,
    styleTabs: PropTypes.string,
};

BoxTabs.defaultProps = {
    children: null,
    uppercase: false,
    styleTabs: 'classic',
    selectedTab: 0,
    onClick: () => null,
};

export default BoxTabs;
